/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateUseremploymentDto } from '../models/work-create-useremployment-dto';
import { WorkUpdateUseremploymentDto } from '../models/work-update-useremployment-dto';
import { WorkUseremployment } from '../models/work-useremployment';

@Injectable({ providedIn: 'root' })
export class WorkUseremploymentsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `useremploymentsV2ControllerFindByUserId()` */
  static readonly UseremploymentsV2ControllerFindByUserIdPath = '/v2/useremployments/byUserId/{userId}';

  /**
   * Required permissions: useremployments:read, useremployments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `useremploymentsV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  useremploymentsV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUseremployment>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUseremploymentsV2Service.UseremploymentsV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUseremployment>>;
      })
    );
  }

  /**
   * Required permissions: useremployments:read, useremployments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `useremploymentsV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  useremploymentsV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkUseremployment>> {
    return this.useremploymentsV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUseremployment>>): Array<WorkUseremployment> => r.body)
    );
  }

  /** Path part for operation `useremploymentsV2ControllerDelete()` */
  static readonly UseremploymentsV2ControllerDeletePath = '/v2/useremployments/{id}';

  /**
   * Required permissions: useremployments:delete, useremployments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `useremploymentsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  useremploymentsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUseremploymentsV2Service.UseremploymentsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: useremployments:delete, useremployments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `useremploymentsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  useremploymentsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.useremploymentsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `useremploymentsV2ControllerUpdate()` */
  static readonly UseremploymentsV2ControllerUpdatePath = '/v2/useremployments/{id}';

  /**
   * Required permissions: useremployments:update, useremployments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `useremploymentsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  useremploymentsV2ControllerUpdate$Response(
    params: {
      id: number;
      skipEmailSending?: boolean;
      body: WorkUpdateUseremploymentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUseremployment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUseremploymentsV2Service.UseremploymentsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('skipEmailSending', params.skipEmailSending, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUseremployment>;
      })
    );
  }

  /**
   * Required permissions: useremployments:update, useremployments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `useremploymentsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  useremploymentsV2ControllerUpdate(
    params: {
      id: number;
      skipEmailSending?: boolean;
      body: WorkUpdateUseremploymentDto
    },
    context?: HttpContext
  ): Observable<WorkUseremployment> {
    return this.useremploymentsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUseremployment>): WorkUseremployment => r.body)
    );
  }

  /** Path part for operation `useremploymentsV2ControllerCreate()` */
  static readonly UseremploymentsV2ControllerCreatePath = '/v2/useremployments';

  /**
   * Required permissions: useremployments:create, useremployments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `useremploymentsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  useremploymentsV2ControllerCreate$Response(
    params: {
      skipEmailSending?: boolean;
      body: WorkCreateUseremploymentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUseremployment>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUseremploymentsV2Service.UseremploymentsV2ControllerCreatePath, 'post');
    if (params) {
      rb.query('skipEmailSending', params.skipEmailSending, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUseremployment>;
      })
    );
  }

  /**
   * Required permissions: useremployments:create, useremployments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `useremploymentsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  useremploymentsV2ControllerCreate(
    params: {
      skipEmailSending?: boolean;
      body: WorkCreateUseremploymentDto
    },
    context?: HttpContext
  ): Observable<WorkUseremployment> {
    return this.useremploymentsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUseremployment>): WorkUseremployment => r.body)
    );
  }

}
